import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Styles from './FormButton.styles';

const Wrapper = styled.div`${Styles.wrapper}`; // prettier-ignore
const Continue = styled.div`${Styles.continue}`; // prettier-ignore

/**
 * Button component
 * @param  {string} className name for the main wrapper css class
 * @param  {bool} disableButton disable status of the button
 * @param  {function} buttonAction button callback 
 * @param  {string} label Button text 
 * @returns {JSX}
 */
const Button = ({
  className, disableButton, buttonAction, label
}) => {
  return (
    <Wrapper
      className={className}
      onClick={!disableButton ? buttonAction : undefined}
      disableButton={disableButton}
    >
      <Continue>{label}</Continue>
    </Wrapper>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  disableButton: PropTypes.bool,
  buttonAction: PropTypes.func
};

export default Button;
